const render = () => {
    if (process.env.NODE_ENV === 'production') {
        const gmtId = process.env.REACT_APP_GTM;
        /** ts-ignore */
        (function(w: any, d: any, s: any, l: any, i: any) {
            w[l] = w[l] || [];
            w[l].push({ event: 'gtm.js', 'gtm.start': new Date().getTime() });
            const f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l !== 'dataLayer' ? '&l=' + l : '';
            // @ts-ignore
            j.async = true;
            // @ts-ignore
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', gmtId);

        const gtmIframe = document.createElement('iframe');
        gtmIframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${gmtId}`);
        gtmIframe.setAttribute('height', '0');
        gtmIframe.setAttribute('width', '0');
        gtmIframe.setAttribute('style', 'display:none;visibility:hidden');

        const gtmNoScript = document.createElement('noscript');
        gtmNoScript.append(gtmIframe);

        document.querySelector('body')?.prepend(gtmNoScript);
    }
};

export default {
    render,
};
